import { Tag } from 'antd'

export const TabCountTag = ({ value }: { value: number }) => (
  <Tag style={{ marginInlineEnd: 0, marginInlineStart: 4, fontSize: 10 }}>
    {value}
  </Tag>
)
